<template>
<div class="col-12">
   <div class="row" style="
    max-width: 95%;
    margin: auto;
">

      <card card-body-classes="table-full-width" style="box-shadow: initial;" no-footer-line>
            <div class="col-md-12 breadcumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }"
          >Home</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $t("app.modules.quick_purchase.title") }}</el-breadcrumb-item>
        <h6 style="margin-bottom: 0px" class="text-right">{{ $t("app.welcome") }}  {{ this.$store.state.user.nombre }} </h6>
      </el-breadcrumb>
      <td class="col-11"></td>
          <td class="col-2"><h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}  </h7></td>
    </div>
    <el-divider></el-divider>
                    <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <h4 class="card-title text-purple">
              {{ $t("app.modules.quick_purchase.title") }}
            </h4>
          </div>
        <div>
          <div class="col-md-4 float-left" v-for="com in this.compras" :key="com.idPedido">
            <card>
                <b>{{ com.codigoProducto }}</b>
                <br />
                <span>
                 {{ $t("app.modules.orders.headers.description") }}: {{ com.producto.textoBreveMaterial }}
                </span>
                <br />
                <span>
                  {{ $t("app.modules.orders.headers.material") }}: {{ com.material }}
                </span>
                <br />
                <span>
                  {{ $t("app.modules.product_family.headers.name") }}: {{ com.producto.familiaProducto.productoPadre }}
                </span>
                <div class="text-center">
                    <n-button native-type="submit" type="primary" @click.native="addItem(com)">
                        {{ $t("app.buttons.add") }}
                    </n-button>
                </div>
            </card>
        </div>
        </div>

      </card>
      <car-item-add />
    </div>
  </div>
</template>
<script>
import ConstPedidoOrigenCreacion from "@/models/pedidos/ConstPedidoOrigenCreacion";

export default {
  components: {
    CarItemAdd: () => import("../components/addItemToCart"),
  },
  computed: {

  },
  data() {
    return {
      compras: [],
      token: "",
      detalles: [],
      origins: new ConstPedidoOrigenCreacion()
    };
  },
  created() {
      this.server = process.env.VUE_APP_API_ENDPOINT;
     if (Object.entries(this.$route.params).length == 0) {
      this.exist_token = false;
    } else {
      this.token = this.$route.params.token;
      this.verifyToken();
    }
  },
  mounted(){
  },
  methods: {
    addItem(item){
      item.origenCreacion = this.origins.EXPRESSFORM;
      EventBus.$emit("show-add.item-cart", item);
    },
    async verifyToken() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      let payload = {
          TokenInvitacion: this.token,
          UsuarioInvitado: 0
      };
      await this.$http
        .post(route("CompraRapida/getProductosByToken"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.compras = response.body.productos;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
      this.$swal.close();
    },
  }
};
</script>





